import { useState } from 'react';
import { api } from '../lib/api';
import type { Alert } from '../lib/api';
import { fmtDateTime, titleCase } from '../lib/format';
import { Empty } from './ui';

const KIND_LABEL: Record<string, string> = {
  new_match: 'Match', deadline_approaching: 'Deadline', solicitation_amended: 'Amended', new_solicitation: 'New notice',
  budget_change: 'Budget', event_recommended: 'Event', mission_need_matched: 'Mission need', transition_stalled: 'Stalled', action_overdue: 'Overdue',
};

export function AlertList({ items, canAck, onChanged, showClient = true, emptyText }: {
  items: Alert[]; canAck: boolean; onChanged: () => void; showClient?: boolean; emptyText?: string;
}) {
  const [busy, setBusy] = useState<string | null>(null);
  async function ack(id: string) {
    setBusy(id);
    try { await api(`/api/alerts/${id}/ack`, { method: 'POST' }); onChanged(); } finally { setBusy(null); }
  }
  if (!items.length) return <Empty>{emptyText ?? 'No open alerts. New strong matches, approaching deadlines, amendments and rule hits land here after every ingest.'}</Empty>;
  return (
    <>
      {items.map((a) => (
        <div className="alert" key={a.id}>
          <span className={`alert-tag ${a.severity}`}>{KIND_LABEL[a.kind] ?? titleCase(a.kind)}</span>
          <div className="alert-body">
            <div>
              {a.target_type === 'solicitation' && a.target_id
                ? <a className="alert-link" href={`#/solicitations/id/${a.target_id}`}>{a.title}</a>
                : a.target_type === 'program' && a.target_id
                  ? <a className="alert-link" href={`#/budget/id/${a.target_id}`}>{a.title}</a>
                  : a.target_type === 'technology' && a.target_id && a.client_profile_id
                    ? <a className="alert-link" href={`#/clients/${a.client_profile_id}/technology/${a.target_id}`}>{a.title}</a>
                    : a.target_type === 'engagement' && a.client_profile_id
                      ? <a className="alert-link" href={`#/clients/${a.client_profile_id}/transition`}>{a.title}</a>
                      : a.title}
            </div>
            <div className="muted sm">
              {showClient && a.client_name ? `${a.client_name} · ` : ''}{a.body ? `${a.body} · ` : ''}{fmtDateTime(a.fired_at)}
              {a.acknowledged_at && ' · acknowledged'}
            </div>
          </div>
          {canAck && !a.acknowledged_at && (
            <button className="ghost-btn ack-btn" disabled={busy === a.id} onClick={() => ack(a.id)} title="Acknowledge">✓</button>
          )}
        </div>
      ))}
    </>
  );
}
